'use strict';

exports.Tabs = require('./Tabs');
exports.TabsPanel = require('./TabsPanel');